import m from "../../geodata/es2015/romaniaLow";
window.am4geodata_romaniaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/romaniaLow.js
// module id = null
// module chunks = 